var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 136,
    viewBox: "0 0 140 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M297.757-1209.113h86.65v-14.461h-86.65Z",
    transform: "translate(-297.757 1223.574)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M433.223-1158.392v10.033h1.134v-1.988l1.546-1.561,2.724,3.549h1.355l-3.3-4.344,3.2-3.269h-1.414l-4.108,4.287v-7.422Zm-1.58,2.419a2.989,2.989,0,0,0-.869.434,3.449,3.449,0,0,0-.707.685,4.058,4.058,0,0,0-.515.869v-1.988h-1.134v7.613h1.134v-3.033a4.447,4.447,0,0,1,.236-1.51,3.138,3.138,0,0,1,.648-1.1,2.656,2.656,0,0,1,.964-.663,3.13,3.13,0,0,1,1.171-.221h.088v-1.222h-.1a3.069,3.069,0,0,0-.919.134m-8.5.065a7.624,7.624,0,0,0-1.281.464l.339.928a6.9,6.9,0,0,1,1.082-.405,4.542,4.542,0,0,1,1.229-.155,2.453,2.453,0,0,1,1.672.523,1.956,1.956,0,0,1,.6,1.553v.265a9.205,9.205,0,0,0-1.06-.236,8.121,8.121,0,0,0-1.281-.088,5,5,0,0,0-1.318.164,3.217,3.217,0,0,0-1.031.471,2.109,2.109,0,0,0-.67.773,2.328,2.328,0,0,0-.236,1.068,2.14,2.14,0,0,0,.243,1.047,2.29,2.29,0,0,0,.648.743,2.824,2.824,0,0,0,.913.449,3.705,3.705,0,0,0,1.038.147,3.26,3.26,0,0,0,1.686-.4,3.727,3.727,0,0,0,1.068-.913v1.148h1.09v-4.653a2.965,2.965,0,0,0-.839-2.291,3.407,3.407,0,0,0-2.4-.773,5.917,5.917,0,0,0-1.488.169m.386,6.708a1.913,1.913,0,0,1-.609-.3,1.5,1.5,0,0,1-.418-.478,1.322,1.322,0,0,1-.154-.648,1.374,1.374,0,0,1,.572-1.163,2.716,2.716,0,0,1,1.644-.427,6.885,6.885,0,0,1,1.255.1q.55.1.976.221v.736a1.756,1.756,0,0,1-.2.832,2.018,2.018,0,0,1-.543.648,2.639,2.639,0,0,1-.807.426,3.11,3.11,0,0,1-.991.155,2.506,2.506,0,0,1-.726-.1",
    transform: "translate(-421.186 1159.108)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M421.192-1159.11h18.794v10.912H421.192Z",
    transform: "translate(-421.192 1159.11)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M433.222-1222.855v10.032h1.134v-1.988l1.546-1.561,2.724,3.549h1.355l-3.3-4.345,3.2-3.269h-1.414l-4.108,4.287v-7.422Zm-1.579,2.419a3.013,3.013,0,0,0-.869.435h0a3.455,3.455,0,0,0-.707.685h0a4.061,4.061,0,0,0-.515.869h0v-1.988h-1.134v7.613h1.134v-3.033a4.449,4.449,0,0,1,.236-1.51h0a3.142,3.142,0,0,1,.648-1.1h0a2.649,2.649,0,0,1,.964-.663h0a3.127,3.127,0,0,1,1.171-.221h.088v-1.223h-.1a3.071,3.071,0,0,0-.919.134m-8.5.065a7.633,7.633,0,0,0-1.281.464h0l.339.927a6.891,6.891,0,0,1,1.082-.405h0a4.574,4.574,0,0,1,1.23-.155h0a2.455,2.455,0,0,1,1.672.523h0a1.957,1.957,0,0,1,.6,1.554h0v.265a9.207,9.207,0,0,0-1.06-.236h0a8.121,8.121,0,0,0-1.281-.088h0a5,5,0,0,0-1.318.162h0a3.208,3.208,0,0,0-1.031.471h0a2.114,2.114,0,0,0-.67.773h0a2.327,2.327,0,0,0-.236,1.068h0a2.138,2.138,0,0,0,.243,1.047h0a2.3,2.3,0,0,0,.648.744h0a2.82,2.82,0,0,0,.913.449h0a3.7,3.7,0,0,0,1.038.148h0a3.259,3.259,0,0,0,1.686-.4h0a3.729,3.729,0,0,0,1.068-.913h0v1.149h1.09v-4.653a2.963,2.963,0,0,0-.839-2.291h0a3.419,3.419,0,0,0-2.4-.773h0a5.925,5.925,0,0,0-1.487.169m.386,6.708a1.915,1.915,0,0,1-.609-.3h0a1.489,1.489,0,0,1-.418-.478h0a1.317,1.317,0,0,1-.154-.648h0a1.374,1.374,0,0,1,.572-1.163h0a2.711,2.711,0,0,1,1.644-.427h0a6.845,6.845,0,0,1,1.255.1h0q.551.1.976.221h0v.736a1.757,1.757,0,0,1-.2.832h0a2.016,2.016,0,0,1-.543.648h0a2.633,2.633,0,0,1-.807.427h0a3.1,3.1,0,0,1-.991.155h0a2.532,2.532,0,0,1-.726-.1",
    transform: "translate(-421.186 1223.572)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(-733.627 -215.895)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 140,
    height: 136,
    transform: "translate(733.627 215.895)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Members",
    transform: "translate(829.627 342.895)",
    fill: "#c4c4c4",
    fontSize: 20,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "EPS")), /*#__PURE__*/React.createElement("g", {
    id: "Group_2830",
    "data-name": "Group 2830",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_17",
    "data-name": "Union 17",
    d: "M24,34,45,0,66,34ZM0,34,11.333,16,22.667,34ZM6.667,3.667a3.667,3.667,0,1,1,3.667,3.667A3.667,3.667,0,0,1,6.667,3.667Z",
    transform: "translate(771.627 253.895)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(645.746 273.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017",
    transform: "translate(119.828 18.192)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011",
    transform: "translate(14.173 23.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M-8.687-11.217a1.505,1.505,0,0,1-1.505-1.505,1.505,1.505,0,0,1,1.505-1.505,1.505,1.505,0,0,1,1.505,1.505,1.505,1.505,0,0,1-1.505,1.505M-6.766-16.4v.335a4,4,0,0,0-2.121-.6,4.025,4.025,0,0,0-4.025,4.025A4.025,4.025,0,0,0-8.887-8.623a4,4,0,0,0,2.121-.6v.446h2.648V-16.4Z",
    transform: "translate(12.912 16.673)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012",
    transform: "translate(9.16 24.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M0-.269H2.7V1.277A2.348,2.348,0,0,1,5.121-.4V2.441H4.895c-1.4,0-2.2.809-2.2,2.582V7.406H0Z",
    transform: "translate(0 0.4)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013",
    transform: "translate(23.336 21.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M-1.851-10.228h-.9v-2.129h.9v-.171a2.685,2.685,0,0,1,.657-2A2.647,2.647,0,0,1,.821-15.2a5.923,5.923,0,0,1,1.772.214v1.915a3.214,3.214,0,0,0-1.014-.157c-.5,0-.772.229-.772.729v.186H2.578v2.086H.849V-4.67h-2.7Z",
    transform: "translate(2.751 15.203)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    transform: "translate(0 23.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M-8.533-10.6a1.479,1.479,0,0,1-1.479-1.479,1.479,1.479,0,0,1,1.479-1.479,1.479,1.479,0,0,1,1.479,1.479A1.479,1.479,0,0,1-8.533-10.6M-6.6-15.509v.581a3.722,3.722,0,0,0-2.341-.824,3.739,3.739,0,0,0-3.74,3.739A3.739,3.739,0,0,0-8.945-8.274,3.723,3.723,0,0,0-6.57-9.125c-.086,1.067-.75,1.646-2.006,1.646a5.146,5.146,0,0,1-1.369-.178l-2.172,1.23-.006.012a8.222,8.222,0,0,0,3.845.88A4.554,4.554,0,0,0-4.9-6.616,4.09,4.09,0,0,0-3.908-9.68v-5.829Z",
    transform: "translate(12.684 15.752)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015",
    transform: "translate(29.006 21.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M0-4.08,2.807-6.065V-4.08Z",
    transform: "translate(0 6.065)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M386.57-1149.67h2.692V-1142h-2.693Z",
    transform: "translate(-357.507 1173.853)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    transform: "translate(32.095 24.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M-17.214,0H-20.5l-.9,1.355L-22.3,0h-3.286l2.572,3.784-2.572,3.873,3.174-.009L-21.4,6.16l1.011,1.488,3.176.009-2.572-3.873Z",
    transform: "translate(25.586)",
    fill: "#c4c4c4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021",
    transform: "translate(119.828 18.192)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(40.389 21.095)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(0.002 -0.001)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018",
    transform: "translate(-137.825 -24.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M-421.192-91.147H207.084V312.514H-421.192Z",
    transform: "translate(421.192 91.147)",
    fill: "#c4c4c4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(114.018 18.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037",
    transform: "translate(14.173 2.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M-8.687-11.217a1.505,1.505,0,0,1-1.505-1.505,1.505,1.505,0,0,1,1.505-1.505,1.505,1.505,0,0,1,1.505,1.505,1.505,1.505,0,0,1-1.505,1.505M-6.766-16.4v.335a4,4,0,0,0-2.121-.6,4.025,4.025,0,0,0-4.025,4.025A4.025,4.025,0,0,0-8.887-8.623a4,4,0,0,0,2.121-.6v.446h2.648V-16.4Z",
    transform: "translate(12.912 16.673)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038",
    transform: "translate(9.16 2.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M0-.269H2.7V1.277A2.348,2.348,0,0,1,5.121-.4V2.441H4.895c-1.4,0-2.2.809-2.2,2.582V7.406H0Z",
    transform: "translate(0 0.4)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039",
    transform: "translate(23.336 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M-1.851-10.228h-.9v-2.129h.9v-.171a2.685,2.685,0,0,1,.657-2A2.647,2.647,0,0,1,.821-15.2a5.923,5.923,0,0,1,1.772.214v1.915a3.214,3.214,0,0,0-1.014-.157c-.5,0-.772.229-.772.729v.186H2.578v2.086H.849V-4.67h-2.7Z",
    transform: "translate(2.751 15.203)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040",
    transform: "translate(0 2.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M-8.533-10.6a1.479,1.479,0,0,1-1.479-1.479,1.479,1.479,0,0,1,1.479-1.479,1.479,1.479,0,0,1,1.479,1.479A1.479,1.479,0,0,1-8.533-10.6M-6.6-15.509v.581a3.722,3.722,0,0,0-2.341-.824,3.739,3.739,0,0,0-3.74,3.739A3.739,3.739,0,0,0-8.945-8.274,3.723,3.723,0,0,0-6.57-9.125c-.086,1.067-.75,1.646-2.006,1.646a5.146,5.146,0,0,1-1.369-.178l-2.172,1.23-.006.012a8.222,8.222,0,0,0,3.845.88A4.554,4.554,0,0,0-4.9-6.616,4.09,4.09,0,0,0-3.908-9.68v-5.829Z",
    transform: "translate(12.684 15.752)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041",
    transform: "translate(29.006 0.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M0-4.08,2.807-6.065V-4.08Z",
    transform: "translate(0 6.065)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M386.57-1214.14h2.692v7.67h-2.693Z",
    transform: "translate(-357.507 1217.023)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042",
    transform: "translate(32.095 2.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M-17.214,0H-20.5l-.9,1.355L-22.3,0h-3.286l2.572,3.784-2.572,3.873,3.174-.009L-21.4,6.16l1.011,1.488,3.176.009-2.572-3.873Z",
    transform: "translate(25.586)",
    fill: "#c4c4c4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    "data-name": "Group 1045",
    transform: "translate(154.328 18.192)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044",
    transform: "translate(-137.823 -3.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M-421.192-26.677H207.084v403.66H-421.192Z",
    transform: "translate(421.192 26.677)",
    fill: "#c4c4c4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1054",
    "data-name": "Group 1054",
    transform: "translate(113.938 18.192)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046",
    transform: "translate(60.537 3.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M0-8.01v-.029a3.836,3.836,0,0,1,3.765-3.867A3.879,3.879,0,0,1,6.72-10.545l-.507.522A3.325,3.325,0,0,0,3.751-11.24,3.052,3.052,0,0,0,.767-8.068v.029A3.106,3.106,0,0,0,1.62-5.8a3.106,3.106,0,0,0,2.188.966A3.3,3.3,0,0,0,6.285-6.07l.493.435A3.8,3.8,0,0,1,3.765-4.172,3.8,3.8,0,0,1,0-8.01",
    transform: "translate(0.001 11.906)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047",
    transform: "translate(67.318 3.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M-14.026-8.01v-.029a3.1,3.1,0,0,0-.85-2.238,3.1,3.1,0,0,0-2.191-.963A3.048,3.048,0,0,0-20.08-8.068v.029A3.1,3.1,0,0,0-19.23-5.8a3.1,3.1,0,0,0,2.191.963A3.048,3.048,0,0,0-14.026-8.01m-6.822,0v-.029a3.817,3.817,0,0,1,1.1-2.729,3.817,3.817,0,0,1,2.712-1.139,3.777,3.777,0,0,1,2.695,1.126,3.777,3.777,0,0,1,1.086,2.711v.029a3.817,3.817,0,0,1-1.1,2.728,3.817,3.817,0,0,1-2.712,1.138A3.777,3.777,0,0,1-19.762-5.3,3.777,3.777,0,0,1-20.848-8.01",
    transform: "translate(20.849 11.906)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048",
    transform: "translate(75.484 3.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M0-.359H.71V.959A2.721,2.721,0,0,1,3.172-.532,2.651,2.651,0,0,1,5.663,1.061,2.933,2.933,0,0,1,8.328-.532a2.777,2.777,0,0,1,2.838,3.085V7.027h-.71V2.639c0-1.593-.825-2.52-2.186-2.52A2.381,2.381,0,0,0,5.937,2.726v4.3H5.229V2.6c0-1.535-.841-2.476-2.16-2.476A2.49,2.49,0,0,0,.71,2.77V7.027H0Z",
    transform: "translate(0 0.533)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049",
    transform: "translate(59.854 9.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M-3.482-2.462l-1.693-1.2v1.2Z",
    transform: "translate(5.175 3.659)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1050",
    "data-name": "Group 1050",
    transform: "translate(60.537 24.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M0-8.01v-.029a3.836,3.836,0,0,1,3.765-3.867A3.879,3.879,0,0,1,6.72-10.545l-.507.522A3.325,3.325,0,0,0,3.751-11.24,3.052,3.052,0,0,0,.767-8.068v.029A3.106,3.106,0,0,0,1.62-5.8a3.106,3.106,0,0,0,2.188.966A3.3,3.3,0,0,0,6.285-6.07l.493.435A3.8,3.8,0,0,1,3.765-4.172,3.8,3.8,0,0,1,0-8.01",
    transform: "translate(0.001 11.906)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    "data-name": "Group 1051",
    transform: "translate(67.318 24.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M-14.026-8.01v-.029a3.1,3.1,0,0,0-.85-2.238,3.1,3.1,0,0,0-2.191-.963A3.048,3.048,0,0,0-20.08-8.068v.029A3.1,3.1,0,0,0-19.23-5.8a3.1,3.1,0,0,0,2.191.963A3.048,3.048,0,0,0-14.026-8.01m-6.822,0v-.029a3.817,3.817,0,0,1,1.1-2.729,3.817,3.817,0,0,1,2.712-1.139,3.777,3.777,0,0,1,2.695,1.126,3.777,3.777,0,0,1,1.086,2.711v.029a3.817,3.817,0,0,1-1.1,2.728,3.817,3.817,0,0,1-2.712,1.138A3.777,3.777,0,0,1-19.762-5.3,3.777,3.777,0,0,1-20.848-8.01",
    transform: "translate(20.849 11.906)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052",
    transform: "translate(75.484 24.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M0-.359H.71V.959A2.721,2.721,0,0,1,3.172-.532,2.651,2.651,0,0,1,5.663,1.061,2.933,2.933,0,0,1,8.328-.532a2.777,2.777,0,0,1,2.838,3.085V7.027h-.71V2.639c0-1.593-.825-2.52-2.186-2.52A2.381,2.381,0,0,0,5.937,2.726v4.3H5.229V2.6c0-1.535-.841-2.476-2.16-2.476A2.49,2.49,0,0,0,.71,2.77V7.027H0Z",
    transform: "translate(0 0.533)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053",
    transform: "translate(59.854 30.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M-3.482-2.462l-1.693-1.2v1.2Z",
    transform: "translate(5.175 3.659)",
    fill: "#c4c4c4"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEps);
export default __webpack_public_path__ + "static/media/eps.2f4d3bcc707927102372350026242669.svg";
export { ForwardRef as ReactComponent };